import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { CustomEase } from "gsap/CustomEase";
import { $qs, $qsa } from '../utils/QuerySelector';
import { media } from '../utils/MediaQueries';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(DrawSVGPlugin);



function initSvgLines() {
  
  const lines = Array('#svg-line-home-1', '#svg-line-home-2', '#svg-line-home-3', '#svg-line-home-4', '#svg-line-home-5', '#svg-line-home-6', '#svg-line-home-7' );
  lines.forEach(function(line, index) {
    if ( line ) {
      gsap.set( line, { drawSVG: "0%" } );
      const tl = gsap.timeline();
      tl.fromTo(line, {
        drawSVG: "0%",
        ease: "none",
      },{
        drawSVG: "100%",
      }, "+=0");
  
      ScrollTrigger.create({
        trigger: line,
        animation: tl,
        start: "top center",
        end: "bottom center",
        // markers: true,
        scrub: true,
        //once: true
      });
    }
  });
  
}

function initAdmissionSvgLine() {
  if (media.sm) return;

  if ( document.querySelector('.page-template-tpl-admissions') ) {
    const triggerStart = document.querySelector('.banner--media')
    const triggerEnd = document.querySelector('.steps-wrapper')
    const svgPathOne = document.querySelector('#svg-line-1')
    let end = $qs('.steps-wrapper').offsetHeight + 1200;
  
    const tlOne = gsap.timeline();
    tlOne.fromTo(svgPathOne, {
      drawSVG: "0%",
      ease: "none",
    },{
      drawSVG: "100%",
    }, "+=0");
  
    ScrollTrigger.create({
      trigger: triggerStart,
      endTrigger: triggerEnd,
      animation: tlOne,
      start: "40% 20%",
      end: () => "+=" + end,
      //end: "155% 80%",
      scrub: true,
      //markers: true
    });
  }

}


function initSVGLines() {
  initSvgLines();
  initAdmissionSvgLine();
}

export default initSVGLines;